/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** 行业报告（Industry Reports） */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** 行业报告（Industry Reports） 清除红点（进入 Reports 页时调用） */
export async function badgeClearPost(options?: RequestOptions) {
  const result = await http.request<model.IApiJsonResultVoid>({
    url: `/es/api/biz/report/badge/clear`,
    method: 'post',
    ...options,
  });

  return result.data;
}

/** 行业报告（Industry Reports） 查询未读报告数（红点） */
export async function badgeCountGet(options?: RequestOptions) {
  const result = await http.request<model.IApiJsonResultBadgeCountResp>({
    url: `/es/api/biz/report/badge/count`,
    method: 'get',
    ...options,
  });

  return result.data;
}

/** 行业报告（Industry Reports） Chat 侧 AI 生成报告完毕落库 */
export async function createReportPost(payload: model.IApiReportCreateReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultReportCreateResult>({
    url: `/es/api/biz/report/create`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** 行业报告（Industry Reports） Following 页 - Topic 维度列表，每条带最新一篇报告（不分页） */
export async function followingListGet(
  payload: {
    topicId?: number;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultFollowingListResp>({
    url: `/es/api/biz/report/following/list`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** 行业报告（Industry Reports） Saved Reports 页 - 报告列表（按 updated_at DESC 分页） */
export async function savedListGet(
  payload: {
    pageNum?: number;
    pageSize?: number;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiPageableResultReportItemResp>({
    url: `/es/api/biz/report/saved/list`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** 行业报告（Industry Reports） Suggested 推荐卡片列表（优先 DB，空时 fallback Apollo 默认） */
export async function suggestionListGet(options?: RequestOptions) {
  const result = await http.request<model.IApiJsonResultSuggestionListResp>({
    url: `/es/api/biz/report/suggestion/list`,
    method: 'get',
    ...options,
  });

  return result.data;
}

/** 行业报告（Industry Reports） Following 页 - Topic 下拉 + totalReportCount */
export async function topicListGet(options?: RequestOptions) {
  const result = await http.request<model.IApiJsonResultTopicListResp>({
    url: `/es/api/biz/report/topic/list`,
    method: 'get',
    ...options,
  });

  return result.data;
}

/** 行业报告（Industry Reports） Follow Topic */
export async function followPost(
  payload: {
    topicId: number;
  },
  options?: RequestOptions
) {
  const result = await http.request<model.IApiJsonResultVoid>({
    url: `/es/api/biz/report/topic/${payload.topicId}/follow`,
    method: 'post',
    ...options,
  });

  return result.data;
}

/** 行业报告（Industry Reports） Refollow Topic */
export async function refollowPost(
  payload: {
    topicId: number;
  },
  options?: RequestOptions
) {
  const result = await http.request<model.IApiJsonResultVoid>({
    url: `/es/api/biz/report/topic/${payload.topicId}/refollow`,
    method: 'post',
    ...options,
  });

  return result.data;
}

/** 行业报告（Industry Reports） Topic 历史报告列表（View history 点击，按 created_at DESC 分页） */
export async function topicReportsGet(
  payload: {
    pageNum?: number;
    pageSize?: number;
    topicId: number;
  },
  options?: RequestOptions
) {
  const params = Object.assign({}, { pageNum: payload.pageNum }, { pageSize: payload.pageSize });

  const result = await http.request<model.IApiPageableResultReportItemResp>({
    url: `/es/api/biz/report/topic/${payload.topicId}/reports`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** 行业报告（Industry Reports） Unfollow Topic */
export async function unfollowPost(
  payload: {
    topicId: number;
  },
  options?: RequestOptions
) {
  const result = await http.request<model.IApiJsonResultVoid>({
    url: `/es/api/biz/report/topic/${payload.topicId}/unfollow`,
    method: 'post',
    ...options,
  });

  return result.data;
}

/** 行业报告（Industry Reports） 报告详情（含 contentBlocks） */
export async function reportDetailGet(
  payload: {
    reportId: number;
  },
  options?: RequestOptions
) {
  const result = await http.request<model.IApiJsonResultReportDetailResp>({
    url: `/es/api/biz/report/${payload.reportId}`,
    method: 'get',
    ...options,
  });

  return result.data;
}

/** 行业报告（Industry Reports） 收藏报告 */
export async function saveReportPost(
  payload: {
    reportId: number;
  },
  options?: RequestOptions
) {
  const result = await http.request<model.IApiJsonResultVoid>({
    url: `/es/api/biz/report/${payload.reportId}/save`,
    method: 'post',
    ...options,
  });

  return result.data;
}

/** 行业报告（Industry Reports） 取消收藏报告 */
export async function unsaveReportDelete(
  payload: {
    reportId: number;
  },
  options?: RequestOptions
) {
  const result = await http.request<model.IApiJsonResultVoid>({
    url: `/es/api/biz/report/${payload.reportId}/save`,
    method: 'delete',
    ...options,
  });

  return result.data;
}
